var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5208 6.44812e-06H67.4792C69.3866 -0.00179242 71.2756 0.372807 73.0382 1.10237C74.8007 1.83193 76.4022 2.90212 77.751 4.25171C79.0997 5.60129 80.1692 7.20377 80.8983 8.96744C81.6274 10.7311 82.0018 12.6213 82 14.5299V65.4701C82.0018 67.3787 81.6274 69.2689 80.8983 71.0326C80.1692 72.7962 79.0997 74.3987 77.751 75.7483C76.4022 77.0979 74.8007 78.1681 73.0382 78.8977C71.2756 79.6272 69.3866 80.0018 67.4792 80H14.5208C12.6134 80.0018 10.7244 79.6272 8.96183 78.8977C7.19927 78.1681 5.59779 77.0979 4.24905 75.7483C2.90031 74.3987 1.83078 72.7962 1.10168 71.0326C0.372574 69.2689 -0.0017913 67.3787 6.44409e-06 65.4701V14.5299C-0.0017913 12.6213 0.372574 10.7311 1.10168 8.96744C1.83078 7.20377 2.90031 5.60129 4.24905 4.25171C5.59779 2.90212 7.19927 1.83193 8.96183 1.10237C10.7244 0.372807 12.6134 -0.00179242 14.5208 6.44812e-06Z",
    fill: "#000B1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4577 65.6419C37.1751 65.6419 40.9993 61.8152 40.9993 57.0949V48.5479H32.4577C27.7402 48.5479 23.916 52.3745 23.916 57.0949C23.916 61.8152 27.7402 65.6419 32.4577 65.6419Z",
    fill: "#0ACF83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.916 40.0001C23.916 35.2797 27.7402 31.4531 32.4577 31.4531H40.9993V48.5471H32.4577C27.7402 48.5471 23.916 44.7205 23.916 40.0001Z",
    fill: "#A259FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.916 22.9064C23.916 18.186 27.7402 14.3594 32.4577 14.3594H40.9993V31.4534H32.4577C27.7402 31.4534 23.916 27.6268 23.916 22.9064Z",
    fill: "#F24E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41 14.3594H49.5417C54.2591 14.3594 58.0833 18.186 58.0833 22.9064C58.0833 27.6268 54.2591 31.4534 49.5417 31.4534H41V14.3594Z",
    fill: "#FF7262"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0833 40.0001C58.0833 44.7205 54.2591 48.5471 49.5417 48.5471C44.8242 48.5471 41 44.7205 41 40.0001C41 35.2797 44.8242 31.4531 49.5417 31.4531C54.2591 31.4531 58.0833 35.2797 58.0833 40.0001Z",
    fill: "#1ABCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/Figma.2bf31033384622da81d3a4a5e19b0389.svg";
export { ForwardRef as ReactComponent };